import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import type { ValidateVendorResponse } from '@leanpay/models'
import { Title } from '@leanpay/ui'

import LpLogoOutline from 'assets/images/lo_logo_outline_img.png'

interface SplashScreenProps {
    validateVendorData?: ValidateVendorResponse | null
}

const SplashScreen = ({ validateVendorData }: SplashScreenProps) => {
    const { t } = useTranslation()
    const [imageError, setImageError] = useState(false)
    const handleImageError = () => setImageError(true)

    return (
        <div className="flex flex-col items-center flex-1 pt-4 w-full bg-white self-center max-w-full">
            <Title className="font-semibold leading-6 text-lp-peach1 mb-7 mt-12 px-4">
                {t('splashScreen.title', { vendorName: validateVendorData?.vendorName })}
            </Title>
            {!imageError && (
                <img
                    alt={validateVendorData?.vendorName}
                    className="mb-9"
                    src={validateVendorData?.vendorLogoUrl}
                    width="243px"
                    onError={handleImageError}
                />
            )}

            <div
                className="flex flex-col items-center justify-center w-full grow px-4"
                style={{
                    background: 'linear-gradient(0deg, #FF698E 40.08%, #FFA667 67.8%, #FFF 98.97%)',
                }}
            >
                <Title className="font-semibold leading-6 text-white mb-6">
                    {t('splashScreen.poweredBy')}
                </Title>
                <img src={LpLogoOutline} width="245px" height="68px" alt="Leanpay Logo" />
            </div>
        </div>
    )
}

export default SplashScreen
